export default function P2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="256"
      height="464"
      fillRule="evenodd"
      clipRule="evenodd"
      imageRendering="optimizeQuality"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      version="1.1"
      viewBox="0 0 256 464"
      xmlSpace="preserve"
    >
      <defs>
        <clipPath clipRule="nonzero">
          <path d="M1515 6513H223V5277h533v429c0 74 60 134 134 134h625z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3334 6513h-722v-673h722z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M2612 6513H1515v-673h83v673z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M2612 6513H1598v-673h1014z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M4626 6513H3334h625v-676c8 2 18 3 27 3h640z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3959 6513h-56v-701c16 13 35 21 56 26v676z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3904 6513h-570v-673h10c103 0 88-65 88-188v-375h420v429c0 43 20 81 52 106z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3344 5840h-10v-563h98v375c0 123 15 188-88 188z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M6445 6513h-722v-673h722z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M5723 6513H4626v-673h83v673z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M5723 6513H4709v-673h1014z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7820 5277h2305v1236h56V5277h-56z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7737 6513H6446h624V5277h750-84v1236z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7070 6513h-56V5277h56z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7015 6513h-570v-673c72-3 129-62 129-134v-429h441z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M6445 5840v-563h129v429c0 72-57 131-129 134z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M10126 6513H8834V5277h1292z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M8834 6513H7737V5277h83v1236z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M8834 6513H7820V5277h1014z"></path>
        </clipPath>
      </defs>
      <g display="inline">
        <path
          fillRule="evenodd"
          d="M5164 4197L5039 4204 5067 4451 5184 4446z"
          className="p2-fil21"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -369.781 -95.97)"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M116.925 328.818L98.3 337.362c-1.248.576-1.824 2.016-1.536 3.264H129.5l-1.248-11.904-11.423.096z"
          className="p2-fil22"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          d="M5399 4197L5274 4204 5302 4451 5419 4446z"
          className="p2-fil21"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -369.781 -95.97)"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M139.484 328.818l-18.624 8.544c-1.247.576-1.823 2.016-1.535 3.264h32.735l-1.248-11.904-11.424.096z"
          className="p2-fil22"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          d="M5378 3228L4958 3238 5024 4371 5451 4371z"
          className="p2-fil23"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -369.781 -95.97)"
        ></path>
        <path
          fillRule="evenodd"
          d="M5078 3236L5077 3238 5154 3434 5216 4372 5218 4373 5219 4371 5157 3433 5080 3237z"
          className="p2-fil24"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -369.781 -95.97)"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M128.348 116.473a9.07 9.07 0 00-2.304 1.248c-6.431 4.991-3.84 16.223.864 21.695 2.592 2.976 6.72 4.704 10.56 3.744 5.568-1.44 7.872-7.392 7.392-12.96-.384-4.128-2.208-8.16-5.376-10.944-3.072-2.687-7.488-4.223-11.232-2.783z"
          className="p2-fil25"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M124.316 132.216l-.864 19.296c-.192 3.551 2.4 6.72 5.952 7.103a6.787 6.787 0 007.584-6.911l-.384-18.048-12.288-1.536z"
          className="p2-fil25"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M136.796 145.944v-2.688s-5.472 1.056-9.792-3.84c0 0 2.208 5.28 9.792 6.528z"
          className="p2-fil26"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M134.396 131.256h-.096c-.288-.288-.864.192-.48.48.576.576 1.632-.192.96-.864-.576-.576-1.632.288-1.056.96.576.672 1.632-.384.864-.864-.768-.576-1.344.672-.48 1.056.384.192.672-.48.192-.672z"
          className="p2-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M135.932 128.184c-1.44-.096-2.88 0-4.32.192-.672.096-.48 1.056.192.96 1.344-.192 2.688-.288 4.128-.192.672 0 .672-.96.096-.96z"
          className="p2-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M143.612 129.624c-.288-.288-.864.192-.48.48.576.576 1.632-.192.96-.864-.576-.576-1.632.288-1.056.96.576.672 1.632-.384.864-.864-.768-.576-1.344.672-.48 1.056.384.192.672-.48.192-.672z"
          className="p2-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M140.06 127.416c1.152-.48 2.496-.768 3.744-.96.576-.096.768.864.192.96-1.248.192-2.4.48-3.552.96-.576.192-.96-.672-.384-.864z"
          className="p2-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M126.908 120.984c1.92-.672 7.392-1.92 14.592.384l-.864-8.735s-12.48-1.44-22.271 4.224l2.112 12.095s1.055.576 2.207.288c.48.48 1.056.672 1.824.384 1.248-.384 1.536-1.728 1.728-2.88.192-1.92.48-3.84.672-5.664z"
          className="p2-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M122.684 130.008c2.112.096 3.84.48 4.224-1.344.384-1.632.288-9.216 3.936-7.584 2.688 1.152 4.704 1.056 8.16.096 1.44-.384 2.592.384 2.592.192 0 0-2.88-8.16-11.52-7.487-2.688.192-4.896 2.112-6.048 4.608-1.44 3.071-1.536 6.815-1.44 10.08l.096 1.535z"
          className="p2-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M139.484 133.752l.768-1.152.096.576c-.384-.288-.576-.576-.768-.864-.192-.288-.288-.672-.384-.96.192.288.48.576.672.768.288.192.576.384.768.384l.48.096-.288.576-1.152.864h-.192v-.192z"
          className="p2-fil27"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M140.828 135.672c-.288.384-.672.768-1.152.96a2.12 2.12 0 01-1.536 0c-.48-.192-.864-.576-1.152-.96-.096-.192-.288-.384-.384-.672-.096-.192-.192-.48-.192-.672l.96.96c.384.288.672.576 1.056.672.384.192.768.192 1.152.096a6.664 6.664 0 001.248-.48z"
          className="p2-fil28"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M140.828 135.672c-.192.48-.672.768-1.152.96-.48.192-1.056.192-1.632 0-.48-.192-.864-.576-1.152-.96-.096-.192-.288-.384-.384-.672-.096-.288-.192-.48-.192-.672.384.288.672.672 1.056.96.384.288.672.576 1.056.672.384.192.768.192 1.152.192.384-.096.864-.192 1.248-.384z"
          className="p2-fil27"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M131.132 131.256h-.192a3.442 3.442 0 003.456 3.456 3.442 3.442 0 003.456-3.456 3.442 3.442 0 00-3.456-3.456 3.441 3.441 0 00-3.456 3.456h.384c0-1.632 1.344-3.072 3.072-3.072 1.632 0 3.072 1.344 3.072 3.072 0 1.632-1.344 3.072-3.072 3.072s-3.072-1.344-3.072-3.072z"
          className="p2-fil1"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M139.868 129.432h-.192a3.442 3.442 0 003.456 3.456 3.442 3.442 0 003.456-3.456 3.442 3.442 0 00-3.456-3.456 3.442 3.442 0 00-3.456 3.456h.384c0-1.632 1.344-3.072 3.072-3.072 1.632 0 3.072 1.344 3.072 3.072 0 1.632-1.344 3.072-3.072 3.072s-3.072-1.344-3.072-3.072z"
          className="p2-fil1"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M125.372 135.96c-1.152.864-2.975 1.152-4.224.48-1.343-.576-2.303-2.016-2.495-3.552-.192-1.344.288-2.88 1.344-3.552 1.056-.672 2.88-.48 3.551.672z"
          className="p2-fil25"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M122.3 133.272c-.287 0-.575-.096-.768-.288-.191-.192-.287-.288-.287-.48 0-.288.192-.576.671-.672a.528.528 0 00.288-.48.528.528 0 00-.48-.288c-.671.192-1.151.672-1.151 1.344 0 .48.192.864.575 1.056.384.288.768.384 1.249.384a.413.413 0 00.383-.384.413.413 0 00-.383-.384z"
          className="p2-fil27"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          d="M5140 2352L5139 2356 5218 2369 5219 2365z"
          className="p2-fil1"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -369.781 -95.97)"
        ></path>
        <path
          fillRule="evenodd"
          d="M5280 2348L5281 2352 5309 2348 5309 2344z"
          className="p2-fil1"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -369.781 -95.97)"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M122.108 150.84l-.48-2.784s7.488 0 8.448 3.936c0 0 2.016-3.648 7.776-4.608v4.224l-8.16 2.495-7.68-3.36z"
          className="p2-fil29"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M153.308 156.695l19.583 5.088s16.224-18.047 16.991-18.623c.769-.672 10.752 2.496 10.752 2.496l-11.52 21.407c-2.783 7.008-6.911 10.944-10.847 11.136l-32.16-6.432 7.297-15.072z"
          className="p2-fil25"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M189.307 144.024s2.207-4.512 2.592-5.184c.767-1.728 1.92-6.048 1.92-6.048s1.343-.288 1.247 2.688c-.096 2.976.48 2.112.48 2.112s6.24-7.584 7.68-7.008c.576.192-.192 2.016-1.248 2.976s-2.112 2.496-2.112 2.496 5.856-5.28 7.2-4.416c0 0 .672.48-1.248 2.112-2.592 2.112-4.32 4.128-4.32 4.128s5.76-4.128 6.432-3.648c1.056.768-4.8 4.896-5.76 6.432 0 0 4.32-3.36 4.512-2.304.096 1.056-5.28 4.8-7.776 10.368z"
          className="p2-fil25"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M193.914 138.36s.48.096 1.056.672c.576.576 1.248 1.536 1.248 2.784l-.384-.096c.864-.96 1.92-1.44 2.688-1.536.768-.096 1.248 0 1.248 0 0 .096-.48.096-1.248.288a5.071 5.071 0 00-2.496 1.536l-.384.384v-.48a3.823 3.823 0 00-1.056-2.592c-.48-.576-.96-.768-.864-.864z"
          className="p2-fil30"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M103.101 155.927l-19.583 5.088s-16.224-18.047-16.992-18.623c-.768-.672-10.752 2.496-10.752 2.496l11.52 21.407c2.784 7.008 6.912 10.944 10.848 11.136l32.159-6.432-7.296-15.072z"
          className="p2-fil25"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M67.102 143.16s-2.208-4.512-2.592-5.184c-.768-1.728-1.92-6.048-1.92-6.048s-1.344-.288-1.248 2.688c.096 2.976-.48 2.112-.48 2.112s-6.24-7.584-7.68-7.008c-.576.192.192 2.016 1.248 2.976s2.112 2.496 2.112 2.496-5.855-5.28-7.2-4.416c0 0-.671.48 1.249 2.112 2.591 2.112 4.32 4.128 4.32 4.128s-5.76-4.128-6.432-3.648c-1.056.768 4.8 4.896 5.76 6.432 0 0-4.32-3.36-4.512-2.304-.096 1.056 5.28 4.8 7.775 10.272l9.6-4.704z"
          className="p2-fil25"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M62.494 137.496c0 .096-.384.288-.864.864-.48.576-1.056 1.536-1.056 2.592v.48l-.384-.384a5.07 5.07 0 00-2.496-1.536c-.768-.192-1.248-.192-1.248-.288 0 0 .48-.192 1.248 0 .768.096 1.92.576 2.688 1.536l-.384.096c0-1.248.672-2.304 1.248-2.784.576-.576 1.056-.672 1.056-.672z"
          className="p2-fil30"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M141.02 151.512c-1.728-.672-3.552-1.056-5.76-1.056-4.608 1.44-9.216 1.44-13.823 0-1.92.192-6.336.48-12.576 2.304l-25.343 8.255-3.84 17.28 28.127-4.704s-2.592 37.15-1.248 43.295l40.99-1.056-1.823-22.56.672-19.68 29.95 4.705-4.127-16.608-31.103-10.08z"
          className="p2-fil29"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M53.95 146.04l-7.2-4.128c-1.247-.672-1.631-2.304-.96-3.456l8.64-14.976c.672-1.248 2.208-1.632 3.456-.96l7.2 4.128c1.248.672 1.632 2.304.96 3.456l-8.64 14.976c-.672 1.248-2.304 1.632-3.456.96z"
          className="p2-fil18"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M171.643 268.244v.48h24.095v-36.383c0-2.976-2.4-5.376-5.375-5.376h-13.92a5.367 5.367 0 00-5.376 5.376v36.383h.48v-.48h.48v-35.903a4.404 4.404 0 014.416-4.416h13.92c2.4 0 4.415 2.016 4.415 4.416v35.423h-23.23v.48h.48-.48z"
          className="p2-fil22"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M178.555 229.461h10.272c1.152 0 2.016-.96 2.016-2.016 0-1.152-.96-2.016-2.016-2.016h-10.272c-1.152 0-2.016.96-2.016 2.016 0 1.152.96 2.016 2.016 2.016z"
          className="p2-fil31"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M165.403 340.242h29.951a6.678 6.678 0 006.72-6.72v-68.926a6.678 6.678 0 00-6.72-6.72h-29.95a6.678 6.678 0 00-6.72 6.72v68.926a6.678 6.678 0 006.72 6.72z"
          className="p2-fil31"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M179.13 340.242h29.952a6.678 6.678 0 006.72-6.72v-68.926a6.678 6.678 0 00-6.72-6.72h-29.951a6.678 6.678 0 00-6.72 6.72v68.926a6.678 6.678 0 006.72 6.72z"
          className="p2-fil32"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M205.05 326.899c.864 0 1.632-.768 1.632-1.632v-52.99c0-.865-.768-1.633-1.632-1.633-.864 0-1.632.768-1.632 1.632v52.99c0 .865.768 1.632 1.632 1.632z"
          className="p2-fil33"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M195.642 326.899c.864 0 1.632-.768 1.632-1.632v-52.99c0-.865-.768-1.633-1.632-1.633-.864 0-1.632.768-1.632 1.632v52.99c0 .865.768 1.632 1.632 1.632z"
          className="p2-fil33"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M186.33 326.899c.865 0 1.633-.768 1.633-1.632v-52.99c0-.865-.768-1.633-1.632-1.633-.864 0-1.632.768-1.632 1.632v52.99c0 .865.768 1.632 1.632 1.632z"
          className="p2-fil33"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
      </g>
    </svg>
  );
}
